import { IRON } from 'constants/colors';

export const genericBorder = (color = IRON, size = '1px', type = 'solid') => {
  const value = `${size} ${type} ${color}`;
  return value;
};
